module.exports = __webpack_public_path__ + "static/media/129.dd4d08e8.webp";